import { PetInfo } from '@app/core/models';
import { selectBreeds } from '@app/store/core';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { weightManagementFeatureKey } from '../weight-management-feature-key';
import { WeightManagementState } from '../weight-management.state';
import { getIbwFromBcsAndLifeStage } from '@app/shared/utils/static-helpers/rationing-helper';
import { selectProfile, selectWeight } from '@app/store/patient-profile/patient-profile.selectors';

const selectState = createFeatureSelector<WeightManagementState>(weightManagementFeatureKey);

export const selectSteps = createSelector(selectState, (state) => state.steps);
export const selectStep = createSelector(selectState, (state) => state.step);

const selectPathologies = createSelector(selectState, (state) => state.pathologies);
/**
 * Deprecated pet info selector for old components compatibilty
 */
export const selectWeightManagementPetSummary = createSelector(
  selectProfile,
  selectWeight,
  selectPathologies,
  selectBreeds,
  (profile, weight, pathologies, breeds) =>
    !!profile &&
    <PetInfo>{
      ...profile,
      breedObject: breeds?.find((b) => b.breedCode === profile.breed),
      bcs: weight?.bcs,
      weight: weight?.currentWeight,
      targetWeight: weight?.targetWeight,
      IBW: getIbwFromBcsAndLifeStage(weight, profile),
      petActivity: weight?.petActivity,
      pathologies: pathologies.filter((p) => !p.isRiskFactor).map((p) => p.value),
      sensitivities: [],
    },
);
